<template>
  <div class="col-lg-12">
    <div class="card-item p-3">
    <label class="title">Ports</label>
    <div class="input-box d-flex justify-content-left" style="padding: 1.0em;"
         v-if="seaTourRouteList != null" v-for="(route, index) in seaTourRouteList" v-bind:key="route.id">
        <div class="row">
          <div class="mr-2 sea-tour-port-list-day-input">
            <base-select-input
                v-model="route.day"
                :optionList="dayList"
                :rules="'required'"/>
          </div>
          <div class="mr-2 sea-tour-port-list-port-input">
            <base-select-input
                v-model="route.portId"
                :optionList="portList"
                :rules="'required'"/>
          </div>
          <div class="sea-tour-port-list-hour-input">
            <base-select-input
                v-model="route.arrivalHour"
                :optionList="hourList"
                :rules="'required'"/>
          </div>
          <div class="mr-2 sea-tour-port-list-hour-input">
            <base-select-input
                v-model="route.arrivalMinute"
                :optionList="minuteList"
                :rules="'required'"/>
          </div>
          <div class="sea-tour-port-list-hour-input">
            <base-select-input
                v-model="route.departureHour"
                :optionList="hourList"
                :rules="'required'"/>
          </div>
          <div class="sea-tour-port-list-hour-input">
            <base-select-input
                v-model="route.departureMinute"
                :optionList="minuteList"
                :rules="'required'"/>
          </div>
          <button @click="removeRoute(route)" class="theme-btn" style="margin-left: 0.8em; margin-top: auto;" type="button">Remove</button>
<!--          <button @click="saveRoute(route)" class="theme-btn" type="button" style="margin-left: 0.8em; margin-top: auto;">Save</button>-->
        </div>
      </div>
    <button @click="addRoute()" class="theme-btn" type="button">Add</button>
    </div>
  </div>
</template>

<script>
import BaseSelectInput from "../base/BaseSelectInput";
import BaseEditInput from "../base/BaseEditInput";
import messagePopupManager from "../../util/messagePopupManager";

// TODO: FIND BETTER NAME
export default {
  name: "SeaTourRoutes",
  components: {BaseSelectInput, BaseEditInput},
  data:function (){
    return{
      minuteList: [
        {id:-1, name: '--'},
        {id:0, name: '00'},
        {id:1, name: '10'},
        {id:2, name: '15'},
        {id:3, name: '20'},
        {id:4, name: '30'},
        {id:5, name: '40'},
        {id:6, name: '45'},
        {id:7, name: '50'},
        {id:8, name: '59'}
      ],
      hourList: [
        {id:-1, name: '--'},
        {id:0, name: '00'},
        {id:1, name: '01'},
        {id:2, name: '02'},
        {id:3, name: '03'},
        {id:4, name: '04'},
        {id:5, name: '05'},
        {id:6, name: '06'},
        {id:7, name: '07'},
        {id:8, name: '08'},
        {id:9, name: '09'},
        {id:10, name: '10'},
        {id:11, name: '11'},
        {id:12, name: '12'},
        {id:13, name: '13'},
        {id:14, name: '14'},
        {id:15, name: '15'},
        {id:16, name: '16'},
        {id:17, name: '17'},
        {id:18, name: '18'},
        {id:19, name: '19'},
        {id:20, name: '20'},
        {id:21, name: '21'},
        {id:22, name: '22'},
        {id:23, name: '23'}

      ],
      dayList: [
        {id:1, name: '1.Gün'},
        {id:2, name: '2.Gün'},
        {id:3, name: '3.Gün'},
        {id:4, name: '4.Gün'},
        {id:5, name: '5.Gün'},
        {id:6, name: '6.Gün'},
        {id:7, name: '7.Gün'},
        {id:8, name: '8.Gün'},
        {id:9, name: '9.Gün'},
        {id:10, name: '10.Gün'},
        {id:11, name: '11.Gün'},
        {id:12, name: '12.Gün'},
        {id:13, name: '13.Gün'},
        {id:14, name: '14.Gün'},

      ]
    }
  },
  computed:{
    seaTourRouteList:{
      get(){
        if(this.$store.getters.getSeaTourRouteList === null){
          return undefined;
        }
        let a =  this.$store.getters.getSeaTourRouteList.sort((a, b) => {
          if(a.day !== b.day){
            return (a.day > b.day) ? 1 : -1;
          }

          let aWeight = a.departureHour !== -1 ? ((a.departureHour*100)+a.departureMinute) : ((a.arrivalHour*100)+a.arrivalMinute);
          let bWeight = b.departureHour !== -1 ? ((b.departureHour*100)+b.departureMinute) : ((b.arrivalHour*100)+b.arrivalMinute);

          return (aWeight > bWeight) ? 1 : -1;
        })
        return a;
      }
    },
    portList:{
      get(){
        return this.$store.getters.getPortList
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    seaTour:{
      get(){
        return this.$store.getters.getSeaTour;
      }
    }
  },
  methods : {
    removeRoute(route){
      this.$store.dispatch("deleteSeaTourRoute",route)
      .then(response => {
        // messagePopupManager.showSuccess()
      })
    },
    saveRoute(route){
      this.$store.commit("setSeaTourRoute", route);
      this.$store.dispatch("updateSeaTourRoute", route).then((seaTourRoute)=>{
        messagePopupManager.showSuccess()
      })
    },
    addRoute(){
      let route = {
        seaTourId : this.seaTour.id,
        day : 1,
        portId : this.portList[0].id,
        departure_hour : 0,
        arrival_hour : 0
      };

      this.$store.commit("setSeaTourRoute", route)
      this.$store.dispatch("saveSeaTourRoute", route).then((response)=>{
        this.seaTourRouteList.push(response);
        // messagePopupManager.showSuccess()
      })
    },
  },
  mounted() {
    // TODO: FIND OUT WHY SELECT VIEWS DOESNT UPDATE HERE
    setTimeout(()=>{
      this.$nextTick(()=>{
        $(".select-contain-select").selectpicker('refresh');
        this.$nextTick(()=>{
          $(".select-contain-select").selectpicker('refresh');
        })
      })
    })
  },
  watch:{
    seaTourRouteList:{
      deep:true,
      handler:function (val){
        val.dirty = true;
      }
    }
  }
}
</script>

<style scoped>

.sea-tour-port-list-day-input{
  width: 120px;
}

.sea-tour-port-list-port-input{
  width: 120px;
}

.sea-tour-port-list-hour-input{
  width: 100px;
}
</style>